import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { CoverageService } from 'services/coverage.service';
import { MapsAPILoader } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { ActiveUserSession } from 'models/activeusersession';
import { NavigationService } from 'services/navigation.service';
import { AlertService } from 'services/alert.service';
import { ScrollService } from 'services/scroll.service';
import { OtherlocationaddressComponent } from '../otherlocationaddress/otherlocationaddress.component';
import { MatDialog } from '@angular/material';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Location } from '@angular/common';
import swal from 'sweetalert2';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-checkcoverage',
  templateUrl: './checkcoverage.component.html',
  styleUrls: ['./checkcoverage.component.scss']
})
export class CheckcoverageComponent implements OnInit {

  addressList = ["Saab", "Volvo", "BMW"];
  title: string = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;
  IsUnitNumberRequired: boolean;
  isEstablishment: boolean;
  map: any;
  marker: any;
  infoBubble: any;
  place: any;
  searchValue: any;
  isSnazzyInfoWindowOpened: boolean = false;
  isCoverageAvailable: boolean = false;
  changeDetectorRef: any;
  coverageAvailableStatus: string;
  width: number = window.innerWidth;
  coverAgePlaceholder: string;
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  mapType: any;
  areaName: any;
  searchQuery: any;
  isShowMap: boolean = true;
  isCoveragePopup: boolean = false;
  isShowAddressPopup: boolean = false;
  locationAdress: any;
  locationItems: any;
  selectedAddress: any;
  locationReference: any;

  activeUserSession = new ActiveUserSession()
  coverageStatus: any;
  locationReferenceAddress: any;
  cityValue: any;
  regionValue: any;
  isHomeConnectCoverageAvailable: boolean = false;
  private homeConnectClientUrl = environment.apiHomeConnectClientUrl;
  isHomeCoverageNavigation: any;
  status: any;
  homeConnectResult: any;
  areaid: number;
  iszoomCoverage: boolean = false;
  zoomAddress: any;
  places: any;
  serviceProviderId: any;
  suburb: any
  amid: any;
  complexName: any;
  complexNumber: any;
  floor: any;
  buildingId: any;
  premiseId: any;
  guid: any;
  ZoomPremiseId: any;
  ZoomLatFromCoverage: any;
  ZoomLongFromCoverage: any;
  constructor(private route: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private coverageService: CoverageService,
    private activeusersession: ActiveUserSession,
    private activeUserSessionService: ActiveUserSessionService,
    public navigationService: NavigationService,
    private router: Router,
    private alertService: AlertService,
    private myService: ScrollService,
    public dialog: MatDialog,
    private _location: Location,



  ) {
    this.route.queryParams.subscribe(params => {

      let latitude = params["latitude"];
      this.latitude = parseFloat(latitude);

      let longitude = params["longitude"];
      this.longitude = parseFloat(longitude);

      this.address = params["address"];
      this.areaName = params["areaName"];
      this.searchQuery = params["searchQuery"];
      let isHomeCoverageNavigation = params["isHomeCoverageNavigation"];
      this.isHomeCoverageNavigation = parseInt(isHomeCoverageNavigation);
      this.status = params["coverageStatus"];

      let hareaId = params["areaId"];
      let tactical = params["tactical"];
      if (tactical == "true")
        localStorage.setItem("Tactical", "TACTICAL");
      else
        localStorage.setItem("Tactical", null);



      this.areaid = parseFloat(hareaId);
    });
  }


  filterAddressLine1(place) {

    var country = this.getNameByAddressType(place, "country").trim().toLowerCase();
    var region = this.getNameByAddressType(place, "administrative_area_level_1").trim().toLowerCase();
    var city = this.getNameByAddressType(place, "locality").trim().toLowerCase();
    var area = this.getNameByAddressType(place, "route").trim().toLowerCase();
    var sublocality = this.getNameByAddressType(place, "sublocality_level_1").trim().toLowerCase();
    var postalcode = this.getNameByAddressType(place, "postal_code").trim().toLowerCase();

    var addressline1 = '';
    let searchqueryIdElement = (document.getElementById("txtsearch") as any);
    if (searchqueryIdElement && searchqueryIdElement.value) {
      var searchquery = searchqueryIdElement.value;
      var addressArray = searchquery.split(',');

      if (addressArray.length > 0) {
        addressArray.forEach(addressitem => {
          var addressstring = addressitem.trim().toLowerCase();

          if (addressstring != country && addressstring != city && addressstring != area && addressstring != sublocality) {
            addressline1 += (addressline1 == '' ? '' : ',') + addressitem;//addressline1 + (addressline1=='' ?'':',') + addressitem;
          }
        });
        addressArray.forEach(addressitem => {
          var addressstring = addressitem.trim().toLowerCase();

          if (addressstring != country && addressstring != city && addressstring != area && addressstring != sublocality) {
            addressline1 += (addressline1 == '' ? '' : ',') + addressitem;//addressline1 + (addressline1=='' ?'':',') + addressitem;
          }
        });
      }
    }
    return addressline1;
  }

  // toggleSnazzyInfoWindow() {
  //   this.isSnazzyInfoWindowOpened = true;
  // }

  checkAddress() {
    debugger
    try {
      const checkRecurringObject = { longitude: this.longitude, latitude: this.latitude, areaId: this.areaid };

      this.coverageService.getLocationReference(checkRecurringObject, true).subscribe(result => {
        debugger
        if (result) {
          this.serviceProviderId = result.serviceProviderId;
          if (result.serviceProviderId == 1) {
            localStorage.setItem('providerId', result.serviceProviderId);
            localStorage.setItem("Kimberley", result.areaName);
            // localStorage.setItem('zoomAddress', "");
            this.locationItems = result.result.response;
            this.isShowMap = false;
            this.isCoveragePopup = false;
            this.isShowAddressPopup = true;
            this.iszoomCoverage = false;

          }
          else if (result.serviceProviderId == 4) {
            this.coverageService.getOpenserveProductQuality(checkRecurringObject, true).subscribe((result) => {
              localStorage.setItem('providerId', this.serviceProviderId);
              if (result) {
                this.suburb = result.value.suburb;
                this.cityValue = result.value.town;
                this.regionValue = result.value.region;
                this.address = result.value.fullAddress;
                this.amid = result.value.amid;
                localStorage.setItem('zoomAddress', this.address);
                localStorage.setItem('AMID', this.amid);
                localStorage.setItem('isOWCP', result.value.isOWCP);
                localStorage.setItem('isOWSP', result.value.isOWSP);
                localStorage.setItem('suburb', result.value.suburb);
                if (result.value.buildingNumberInfo != null) {
                  this.isShowAddressPopup = true;
                  this.iszoomCoverage = false;
                  this.locationItems = result.value.buildingNumberInfo.buildingInfo;
                  this.isShowMap = false;
                  this.isCoveragePopup = false;
                  localStorage.setItem('isComplexAddress', "true");
                }
                else {
                  this.CreateSession1();
                  this.navigationService.goToProduct();
                }
              }

            })
          }

          else {
            this.iszoomCoverage = true;
            this.zoomAddress = this.address;
            this.coverageService.getZoomLocationPremises({ premiseAddress: this.address }).subscribe((result) => {

              localStorage.setItem('zoomAddress', this.zoomAddress);
              localStorage.setItem('providerId', this.serviceProviderId);
              this.CreateSession1();
              this.locationItems = result.items;
              this.isShowMap = false;
              this.isCoveragePopup = false;
              this.isShowAddressPopup = true;
              this.iszoomCoverage = false;

              // this.navigationService.goToProduct();
            });
          }
        }
      });

    } catch (error) {

    }
  }

  // snazzyInfoWindowIsToggled($isOpen: boolean) {
  //   this.isSnazzyInfoWindowOpened = $isOpen;
  //   this.changeDetectorRef.detectChanges();
  // }
  snazzyInfoWindowIsToggled(event) {

  }

  getNameByAddressType(place, type) {
    var res = '';
    if (place) {
      place.address_components.forEach(address => {
        address.types.forEach(addresstype => {
          if (addresstype == type) {
            res = address.long_name;
            return false;
          }
        });
      });
    }

    return res;
  }

  filterHouseNumber(street, addressline1) {
    var housenumber = '';

    housenumber = addressline1.replace(street, '');

    return housenumber;
  }

  getLocality(place) {
    var localityName = '';
    if (place) {
      place.address_components.forEach(address => {
        if (address.types[0] == "locality") {
          localityName = address.long_name;
          return false;
        }
      });
    }

    return localityName;
  }

  checkCoverage(latitude, longitude, place) {
    debugger
    this.isShowMap = true;
    this.isShowAddressPopup = false;
    var formatted_address = place.formatted_address;
    let searchqueryIdElement = (document.getElementById("txtsearch") as any);
    if (searchqueryIdElement && searchqueryIdElement.value) {
      formatted_address = searchqueryIdElement.value;
    }
    var country, region, city, area, sublocality, postalcode, street_number;

    if (place.address_components) {
      debugger

      var addressline1 = this.filterAddressLine1(place);
      country = this.getNameByAddressType(place, "country");
      region = this.getNameByAddressType(place, "administrative_area_level_1");
      city = this.getNameByAddressType(place, "locality");
      area = this.getNameByAddressType(place, "route");
      sublocality = this.getNameByAddressType(place, "sublocality_level_1");
      postalcode = this.getNameByAddressType(place, "postal_code");
      street_number = this.getNameByAddressType(place, "street_number");

      this.IsUnitNumberRequired = this.isEstablishment;

      var address = place.address_components;

      let searchInput = (document.getElementById("txtsearch") as any);
      if (searchInput && searchInput.value) {
        this.searchValue = searchInput.value;
      }

      var placeDetails = {

        latitude: latitude,
        longitude: longitude,
        placeName: formatted_address,
        addressLine1: this.isEstablishment ? addressline1 : ((this.getNameByAddressType(place, "street_number") || this.getNameByAddressType(place, "subpremise")) || this.filterHouseNumber(area, addressline1)),
        addressLine2: area + (sublocality != city ? ',' + sublocality : ''), //address[1] ? address[1].long_name : '',
        city: city,
        region: region,
        pinCode: postalcode,
        isUnitNumberRequired: this.IsUnitNumberRequired,
        searchQuery: this.searchValue,
      };
    }


    var localityName = this.getLocality(place);
    var providerId;
    var searchInput;
    let searchInput2 = (document.getElementById("txtsearch") as any);
    if (searchInput2 && searchInput2.value) {
      searchInput = searchInput2.value;
    }
    var paramFilters = {
      latitude: latitude,
      longitude: longitude,
      address: formatted_address,
      areaName: this.getNameByAddressType(place, "route"),
      searchQuery: searchInput,
      IsCheckHomeConnectCoverage: false,
    };

    this.isSnazzyInfoWindowOpened = false;
    this.isCoverageAvailable = false;

    this.coverageService.checkHomeCoverage(paramFilters).subscribe(result => {
      debugger
      this.isCoveragePopup = true;
      this.isSnazzyInfoWindowOpened = true;
      this.coverageStatus = result.coverageStatus;
      this.areaid = result.areaId;
      this.coverageAvailableStatus = "Coverage Not Available";
      if (result) {
        let amid = null;

        this.homeConnectResult = result;
        if (result.isAvailable && result.isVumaReachCoverage) {
          this.isCoverageAvailable = true;
          this.isHomeConnectCoverageAvailable = false;
          this.coverageAvailableStatus = "Coverage Available";
          amid = result.amid;
          localStorage.setItem("AMID", amid);
          if (result.tag && result.tag.length > 0 && result.tag.includes("TACTICAL"))
            localStorage.setItem("Tactical", "TACTICAL");
          else
            localStorage.setItem("Tactical", null);
          // Skip the Coverage Available page
          this.checkAddress();
        }
        else if (result.isAvailable && !result.isVumaReachCoverage) {
          this.isHomeConnectCoverageAvailable = true;
        }
        else
          this.isHomeConnectCoverageAvailable = false;
      }
    });
  }


  checkHomeCoverage() {

    this.isShowAddressPopup = false;
    var paramFilters = {
      latitude: this.latitude,
      longitude: this.longitude,
      address: this.address,
      areaName: this.areaName,
      searchQuery: null,
      IsCheckHomeConnectCoverage: false,
    };

    this.isSnazzyInfoWindowOpened = false;
    this.isCoverageAvailable = false;

    this.coverageService.checkHomeCoverage(paramFilters).subscribe(result => {
      debugger
      this.isCoveragePopup = true;
      this.isSnazzyInfoWindowOpened = true;
      this.coverageStatus = result.coverageStatus;
      this.coverageAvailableStatus = "Coverage Not Available";
      this.homeConnectResult = result;
      this.areaid = result.areaId;
      if (result) {
        if (result.isAvailable && result.isVumaReachCoverage) {
          this.isCoverageAvailable = true;
          this.coverageAvailableStatus = "Coverage Available";
          if (result.tag && result.tag.length > 0 && result.tag.includes("TACTICAL"))
            localStorage.setItem("Tactical", "TACTICAL");
          else
            localStorage.setItem("Tactical", null);
          this.checkAddress();
        }
        else if (result.isAvailable && result.isVumaReachCoverage) {
          this.isHomeConnectCoverageAvailable = true;
        }
        else
          this.isHomeConnectCoverageAvailable = false;
      }
    });
  }

  IsUnitNumberIsRequired(address) {

    var isRequired = false;
    var unitNumberservicetypes = ['subpremise', 'street_number'];
    var establishmenttypes = ['establishment'];

    this.IsUnitNumberRequired = false;

    if (address.types != undefined) {
      for (var j = 0; j < address.types.length; j++) {
        if (establishmenttypes.indexOf(address.types[j]) != -1) {
          this.isEstablishment = true;
          this.IsUnitNumberRequired = true;
          break;
        }
      }
    }
    if (!this.IsUnitNumberRequired) {
      if (address.address_components != undefined) {

      }
      if (address.address_components != undefined) {
        for (var i = 0; i < address.address_components.length; i++) {
          var c = address.address_components[i];

          for (var j = 0; j < c.types.length; j++) {
            if (unitNumberservicetypes.indexOf(c.types[j]) != -1) {
              this.IsUnitNumberRequired = true;
              break;
            }
          }

          if (this.IsUnitNumberRequired)
            break;
        }
      } else if (address.types != undefined) {
        for (var j = 0; j < address.types.length; j++) {
          if (unitNumberservicetypes.indexOf(address.types[j]) != -1) {
            this.IsUnitNumberRequired = true;
            break;
          }
        }
      }
      isRequired = !this.IsUnitNumberRequired;
    }
    else
      isRequired = this.IsUnitNumberRequired;

    return isRequired;
  }

  checkCoverageGetPlace(place) {


    this.isEstablishment = false;

    var message = "Please provide us with a street name and number in order to confirm the availability of fibre in your area"
    //this.clearMarker();

    if (place && place.geometry != undefined) {
      if (place && place.geometry) {
        this.checkCoverage(place.geometry.location.lat(), place.geometry.location.lng(), place);

        // var isEstablishment = false;
        // this.IsUnitNumberIsRequired(place);
        // if (!this.hasStreet(place) && !isEstablishment) {
        //   this.alertService.warning(message);
        //   // modalService.warrningMessageModel('Incomplete Address', message, true)
        //   //     .result.then(
        //   //         function () {

        //   //         });
        //   // return;
        // }
        // //if (!hasStreet(place))
        // //    log.error('Inadequate Address', 'Please try with the specific address');
        // else {
        //   //IsUnitNumberRequired = IsUnitNumberIsRequired(place);
        //   this.checkCoverage(place.geometry.location.lat(), place.geometry.location.lng(), place);
        //   //checkCoverage(place.geometry.location.lat(), place.geometry.location.lng(), place.formatted_address)
        // }
      } else {
        this.alertService.warning(message);
        // modalService.warrningMessageModel('Incomplete address', message, true)
        //         .result.then(
        //             function () {

        //             });
        //this.clearMarker();
      }
    } else {
      this.alertService.warning(message);
      // modalService.warrningMessageModel('Incomplete Address', message, true)
      //          .result.then(
      //              function () {

      //              });
    }

  }

  hasStreet(address) {
    var placeservicetypes = ['route', 'street_address', 'street_number', 'premise'];
    var isStreetFound = false;
    if (address.address_components != undefined) {

    }
    if (address.address_components != undefined) {
      for (var i = 0; i < address.address_components.length; i++) {
        var c = address.address_components[i];

        for (var j = 0; j < c.types.length; j++) {
          if (placeservicetypes.indexOf(c.types[j]) != -1) {
            isStreetFound = true;
            break;
          }
          //if (c.types[j] == "street_number" || c.types[j] == "route") {
          //    isStreetFound = true;
          //    break;
          //}
        }

        if (isStreetFound)
          break;
      }
    } else if (address.types != undefined) {
      for (var j = 0; j < address.types.length; j++) {
        if (placeservicetypes.indexOf(address.types[j]) != -1) {
          isStreetFound = true;
          break;
        }
        //if (address.types[j] == "establishment" || address.types[j] == "street_number" || address.types[j] == "route") {
        //    isStreetFound = true;
        //    break;
        //}
      }
    }

    return isStreetFound;
  }

  // clearMarker() {
  //   if (marker && infoBubble) {
  //       marker.setMap(null);
  //       infoBubble.close();
  //   }
  // }

  loadMapInit() {

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        componentRestrictions: {
          country: ["ZA"]
        }
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            this.alertService.warning('Please provide us valid address to confirm the availability of fibre in your area');
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 18;

          this.checkCoverageGetPlace(place);

          //this.checkCoverage(this.latitude, this.longitude, place);
        });
      });
    });
  }


  ngOnInit() {
    debugger
    // localStorage.removeItem("Tactical");

    localStorage.removeItem("isZoomProductFromHC");
    if (this.width < 760) {
      this.coverAgePlaceholder = "Please enter complete address";
    }
    else {
      this.coverAgePlaceholder = "Please enter complete address / complex name";
    }
    this.loadMapInit();
    //this.checkHomeCoverage();

    if (!this.isHomeCoverageNavigation) {
      this.checkHomeCoverage();
    }
    else {
      this.isCoveragePopup = true;
      this.isSnazzyInfoWindowOpened = true;
      this.isCoverageAvailable = true;
      this.coverageAvailableStatus = "Coverage Available";
      this.coverageStatus = this.status;

    }
    //   var mapId = document.getElementById("map_div");
    //   var defaultJbLatlong = new google.maps.LatLng(-26.1127906, 28.147499400000015);

    //   var map = new google.maps.Map(mapId, {
    //     center: defaultJbLatlong,
    //     zoom: 18,
    //     mapTypeId: google.maps.MapTypeId.HYBRID
    // });
    this.activeUserSessionService.destroyUnitName();
    this.activeUserSessionService.destroyUnitNo();
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {

    // this.latitude = -26.1127906;
    // this.longitude = 28.147499400000015;
    this.zoom = 18;
    this.mapType = google.maps.MapTypeId.HYBRID;
    // if ('geolocation' in navigator) {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     this.latitude = position.coords.latitude;
    //     this.longitude = position.coords.longitude;
    //     this.zoom = 8;
    //     this.getAddress(this.latitude, this.longitude);
    //   });
    // }
  }


  markerDragEnd($event: any) {
    //console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude, longitude) {

    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      //console.log(results);
      //console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 18;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }


  // Get row item from array  
  // getSelecteditem(){
  //   this.radioSel = this.ITEMS.find(Item => Item.value === this.radioSelected);
  //   this.radioSelectedString = JSON.stringify(this.radioSel);
  // }
  // Radio Change Event
  onItemChange(item: any) {
    if (this.serviceProviderId == 1) {
      this.selectedAddress = item.address;
      this.locationReference = item.premise_ref_isp;
      this.cityValue = item.suburb;
      this.regionValue = item.province;
      this.myService.triggerScrollTo();
    }
    else if (this.serviceProviderId == 2) {
      this.selectedAddress = item.full_text;
      this.premiseId = item.premise_id;
      this.guid = item.guid;
      this.ZoomPremiseId = item.id;
      this.ZoomLatFromCoverage = item.latitude;
      this.ZoomLongFromCoverage = item.longitude;
    }
    else {
      this.selectedAddress = item.buildinG_NAME;
      this.locationReference = item.num;
      this.floor = item.floor;
      this.buildingId = item.blD_NUM_ID;
      this.myService.triggerScrollTo();
    }
    //this.getSelecteditem();
  }

  CreateSession() {
    this.activeUserSession.address = this.address;
    this.activeUserSession.latitude = this.latitude;
    this.activeUserSession.longitude = this.longitude;
    this.activeUserSession.locationReference = this.locationReference;
    this.activeUserSession.coverageStatus = this.coverageStatus;
    this.activeUserSession.addressLine1 = this.address;
    this.activeUserSession.city = this.cityValue
    this.activeUserSession.region = this.regionValue;
    this.activeUserSession.suburb = this.suburb;
    this.activeUserSession.amId = this.amid;
    if (localStorage.getItem("isComplexAddress") === "true") {
      this.activeUserSession.complexName = this.selectedAddress;
      this.activeUserSession.complexNumber = this.locationReference;
      this.activeUserSession.buildingId = this.buildingId;
      this.activeUserSession.floor = this.floor;


    }

    // this.activeUserSession.pincode = 0;
    this.activeUserSessionService.create(this.activeUserSession);
  }
  specificaddress() {
    var addressline1 = this.filterAddressLine1(this.places);
    var country = this.getNameByAddressType(this.places, "country");
    var region = this.getNameByAddressType(this.places, "administrative_area_level_1");
    var city = this.getNameByAddressType(this.places, "locality");
    var postalcode = this.getNameByAddressType(this.places, "postal_code");
    var placeDetails1 = {

      // latitude: latitude,
      // longitude: longitude,
      // placeName: formatted_address,
      addressLine1: addressline1,
      // addressLine2: area + (sublocality != city ? ',' + sublocality : ''), //address[1] ? address[1].long_name : '',
      city: city,
      region: region,
      pinCode: postalcode,
      // isUnitNumberRequired: this.IsUnitNumberRequired,
      // searchQuery: this.searchValue,
    };
    return placeDetails1;
  }

  CreateSession1() {
    var placesss = this.specificaddress();
    this.activeUserSession.latitude = this.latitude;
    this.activeUserSession.longitude = this.longitude;
    this.activeUserSession.locationReference = '';
    this.activeUserSession.coverageStatus = this.coverageStatus;
    this.activeUserSession.addressLine1 = this.address;
    this.activeUserSession.city = this.cityValue
    this.activeUserSession.region = this.regionValue;
    this.activeUserSession.suburb = this.suburb;
    this.activeUserSession.amId = this.amid;
    // this.activeUserSession.pincode = placesss.pinCode;
    this.activeUserSessionService.create(this.activeUserSession);
  }

  onProceed() {
    debugger
    if (this.serviceProviderId == 1) {
      const datas = {
        premise_ref_isp: this.locationReference,
      }

      this.coverageService.checkCanCreateOrder(datas).subscribe(result => {
        if (result) {

          if (this.selectedAddress != undefined) {

            this.CreateSession();

            this.navigationService.goToProduct();

          }
          else {
            this.alertService.warning('Please Select Addres');
          }


        }
        else {

          swal.fire({
            title: 'This location has an active installation order with another ISP. You may not place an order for this address.',
            //  html:  +result.value.vumatelApiErrorMessage ,                   
            text: "In order to proceed, please cancel your order with the current ISP.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {

            }
          });

        }
      });
    }

    else if (this.serviceProviderId == 2) {

      if (this.selectedAddress != undefined) {
        this.CreateSession();
        const zoomPortalRedirectCoverageData = {
          isZoomFromCoveragePage: true,
          premiseId: this.ZoomPremiseId,
          latitude: this.ZoomLatFromCoverage,
          longitude: this.ZoomLongFromCoverage
        };

        localStorage.setItem("zoomPortalRedirectCoverageData", JSON.stringify(zoomPortalRedirectCoverageData));
        this.navigationService.goToProduct();

      }
      else {
        this.alertService.warning('Please Select Addres');
      }
    }
    else {
      this.CreateSession();
      this.navigationService.goToProduct();
    }

  }


  otherAddress() {
    const dialogRef = this.dialog.open(OtherlocationaddressComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      data: true,
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data) {

        this.locationItems = data.response;
        this.isShowMap = false;
        this.isCoveragePopup = false;
        this.isShowAddressPopup = true;

      }
    });

  }


  goBack() {
    this._location.back();
  }

  goToHomeConnect() {
    var resultsValue = JSON.stringify(this.homeConnectResult);
    var url = this.homeConnectClientUrl + "?latitude=" + this.latitude + "&longitude=" + this.longitude + "&address=" + this.address + "&areaName=" + this.areaName + "&results=" + resultsValue;
    var newWindow = window.open(url);
  }


}